import AccountSetting from "../Component/Pages/AccountSeetting";
import Branches from "../Component/Pages/Branches";
import Courselist from "../Component/Pages/CourseList/Courselist";
import Viewdetail from "../Component/Pages/CourseList/viewdetail";
import Course from "../Component/Pages/Courses";
import CreateCourse from "../Component/Pages/Courses/CreateCourse";
import CourseStore from "../Component/Pages/CourseStore";
import Dashboard from "../Component/Pages/Dashboard";
import CreateEditGroup from "../Component/Pages/Group/createEdit-Group";
import Groups from "../Component/Pages/Groups";
import AddGroup from "../Component/Pages/Groups/AddGroup";
import InputField from "../Component/Pages/InputField";
import Login from "../Component/Pages/Login";
import Createformpeople from "../Component/Pages/People/Createform";
import EditForm from "../Component/Pages/People/Editform";
import PeopleMenu from "../Component/Pages/People/Peoplemenu";
import Permission from "../Component/Pages/Permission";
import Activitylog from "../Component/Pages/Reports/ActivityLog/activitylog";
import BranchesReport from "../Component/Pages/Reports/BranchesReport";
import ReportCourse from "../Component/Pages/Reports/Course/ReportCourse";
import ReportGroup from "../Component/Pages/Reports/Course/ReportGroup";
import GroupDesign from "../Component/Pages/Reports/Course/GroupDesign";
import CourseReport from "../Component/Pages/Reports/CourseReport";
import Coursetask from "../Component/Pages/Reports/CourseTask/coursetask";
import Designtask from "../Component/Pages/Reports/CourseTask/designtask";
import CustomeReport from "../Component/Pages/Reports/CustomReport";
import GroupReport from "../Component/Pages/Reports/GroupReport";
import LearningActivies from "../Component/Pages/Reports/LearningActivities";
import Reportsfile from "../Component/Pages/Reports/People/Reports";
import TimelineReports from "../Component/Pages/Reports/TimeLine";
import UserReport from "../Component/Pages/Reports/UserReport";
import Accounts from "../Component/Pages/Settings/Account";
import Category from "../Component/Pages/Settings/Category/category";
import Certificate from "../Component/Pages/Settings/Course/Certificate";
import Courses from "../Component/Pages/Settings/Course/CourseField";
import Editcertificate from "../Component/Pages/Settings/Course/editcertificate";
import CreatingPeopleType from "../Component/Pages/Settings/People/CreatingPeople";
import Peoples from "../Component/Pages/Settings/People/customfield";
import EditPeople from "../Component/Pages/Settings/People/EditCreatingPeople";
import EditCustomField from "../Component/Pages/Settings/People/EditCustom";
import Users from "../Component/Pages/Users";
import AddUser from "../Component/Pages/Users/AddUser";
import EditUser from "../Component/Pages/Users/EditUser";
// import Addcertificate from "../Component/Pages/Addcertificate/Addcertificate";
import AddCertificateFlow from "../Component/Pages/Addcertificate/Addcertificateflow";
import GroupDetails from "../Component/Pages/Groups/GroupDetails";
import Reportpeoplegroup from "../Component/Pages/Groups/Reportpeoplegroup";
import PeopleReport from "../Component/Pages/Reports/People/PeopleReport";
import GroupReportPage from "../Component/Pages/Reports/CourseReport";
import GroupDetailsPage from "../Component/Pages/Reports/CourseReport/ViewCourse";
import ComingSoon from "../Component/Pages/ComingSoon";
import Scoring from "../Component/Pages/Scoring";
import LearnerDashboard from "../Component/Pages/LearnerDashboard";
import MyCourse from "../Component/Pages/MyCourse";
import LearnerCourseList from "../Component/Pages/LearnerCourseList";
import MyScores from "../Component/Pages/MyScores";
import CoursePlayer from "../Component/Pages/CoursePlayer";
import Conference from "../Component/Pages/Conference";
import CalendarPage from "../Component/Pages/Calendar";
import Messages from "../Component/Pages/Messages";
import MessageCompose from "../Component/Pages/Messages/Compose";
import ViewMessage from "../Component/Pages/Messages/ViewMessage";
import Notification from "../Component/Pages/Notification";

const unProtectedRoutes = [
  {
    path: "/",
    component: <Login />,
  },
  {
    // path: "/login",
    // component: <Login />,
  },
];

const protectedRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
    key: "dashboard",
  },
  {
    path: "/tutor-dashboard",
    component: <Dashboard />,
    key: "dashboard",
  },
  {
    path: "/scoring",
    component: <Scoring />,
    key: "dashboard",
  },
  {
    path: "/learner-dashboard",
    component: <LearnerDashboard />,
    key: "dashboard",
  },
  {
    path: "/my-course",
    component: <MyCourse />,
    key: "dashboard",
  },
  {
    path: "/learner-course-list",
    component: <LearnerCourseList />,
    key: "dashboard",
  },
  {
    path: "/my-scores",
    component: <MyScores />,
    key: "dashboard",
  },
  {
    path: "/course-player",
    component: <CoursePlayer />,
    key: "dashboard",
  },
  {
    path: "/conference",
    component: <Conference />,
    key: "dashboard",
  },
  {
    path: "/calendar",
    component: <CalendarPage />,
    key: "dashboard",
  },
  {
    path: "/users",
    component: <Users />,
    key: "dashboard",
  },
  {
    path: "/users/adduser",
    component: <AddUser />,
    key: "dashboard",
  },
  {
    path: "/users/edit",
    component: <EditUser />,
    key: "dashboard",
  },
  {
    path: "/course",
    component: <Course />,
    key: "dashboard",
  },
  {
    path: "/groups",
    component: <Reportpeoplegroup />,
    key: "dashboard",
  },
  {
    path: "/addgroup",
    component: <AddGroup />,
    key: "dashboard",
  },
  {
    path: "/branches",
    component: <Branches />,
    key: "dashboard",
  },
  {
    path: "/course-store",
    component: <CourseStore />,
    key: "dashboard",
  },
  {
    path: "/course-report",
    component: <GroupReportPage />,
    key: "dashboard",
  },{

    path:"/group-report/:groupId",
    component: <GroupDetailsPage />,
    key: "dashboard", 
  },
  {
    path: "/user-report",
    component: <UserReport />,
    key: "dashboard",
  },
  {
    path: "/branches-report",
    component: <BranchesReport />,
    key: "dashboard",
  },
  {
    path: "/group-report",
    component: <GroupReport />,
    key: "dashboard",
  },
  {
    path: "/settings-account",
    component: <Accounts />,
    key: "dashboard",
  },
  {
    path: "settings-people",
    component: <Peoples />,
    key: "dashboard",
  },
  {
    path: "settings-peopletype",
    component: <CreatingPeopleType />,
    key: "dashboard",
  },
  {
    path: "settings-course",
    component: <Courses />,
    key: "dashboard",
  },
  {
    path: "settings-category",
    component: <Category/>,
    key: "dashboard",
  },
  {
    path: "custom-edit",
    component: <EditCustomField />,
    key: "dashboard",
  },
  {
    path: "people-edit",
    component: <EditPeople/>,
    key: "dashboard",
  },
  {
    path: "/learning-activities",
    component: <LearningActivies />,
    key: "dashboard",
  },
  {
    path: "/custom-reports",
    component: <CustomeReport />,
    key: "dashboard",
  },
  {
    path: "/report/tab/:tab",
    component: <TimelineReports />,
    key: "dashboard",
  },

  {
    path: "/account/tab/:tab",
    component: <AccountSetting />,
    key: "dashboard",
  },
 
  {
    path: "/permission",
    component: <Permission />,
    key: "permission",
  },
  {
    path: "/input",
    component: <InputField />,
    key: "permission",
  },
  {
    path: "/people",
    component: <PeopleMenu/>,
    key: "people",
  },
  {
    path: "/Createformpeople",
    component: <Createformpeople/>,
    key: "Createformpeople",
  }, {
    path: "/editForm",
    component: <EditForm/>,
    key: "EditForm",
  },
  {
    path: "/account-report",
    component: <Reportsfile/>,
    key: "course-report",
  },

 
  {
    path: "certificate",
    component: <Certificate />,
    key: "certificate",
  },
  {
    path: "editcertificate",
    component: <Editcertificate />,
    key: "permission",
  },
  {
    path: "courselist",
    component: <Courselist />,
    key: "permission",
  },
  {
    path: "createEditgroup",
    component: <CreateEditGroup />,
    key: "permission",
  },
  {
    path: "viewdetail",
    component: <Viewdetail />,
    key: "permission",
  },
  {
    path: "activitylog",
    component: <Activitylog />,
    key: "dashboard",
  },
  {
    path: "coursetask",
    component: <Coursetask />,
    key: "dashboard",
  },
  {
    path: "designtask/:taskId",
    component: <Designtask />,
    key: "dashboard",
  },
  {
    path: "reportcourse",
    component: <ReportCourse />,
    key: "dashboard",
  },
  {
    path: "reportgroup",
    component: <ReportGroup />,
    key: "dashboard",
  },
  {
    path: "groupdesign",
    component: <GroupDesign />,
    key: "dashboard",
  },
  {
    path: "/CreateCourse",
    component: <CreateCourse />,
    key: "permission",
  },
    {
    path: "/addcertificate",
    component: <AddCertificateFlow/>,
    key: "permission",
  },
  {
    path: "/group/:groupId",
    component: <GroupDetails />,
    key: "permission",
  },
  
    {
    path: "/people-report",
    component: <PeopleReport />,
    key: "permission",
  },
  {
    path: "/messages",
    component: <Messages />,
    key: "dashboard",
  },
  {
    path: "/messages/compose",
    component: <MessageCompose />,
    key: "dashboard",
  },
  {
    path: "/messages/view/:messageId",
    component: <ViewMessage />,
    key: "dashboard",
  },
  {
    path: "/notification",
    component: <Notification />,
    key: "dashboard",
  },
  {
    path: "/messages/reply/:messageId",
    component: <MessageCompose />,
    key: "dashboard",
  },
  {
    path: "/messages/forward/:messageId",
    component: <MessageCompose />,
    key: "dashboard",
  },
];

export const routesData = { unProtectedRoutes, protectedRoutes };
